<template>
  <div>
    <!-- Search location -->
    <el-col :span="24">
      <div class="googlesearchgroup search-location-input">
        <gmap-autocomplete
          id="autocomplete"
          :placeholder="$t('locationSelector.address-cadastral-gps')"
          :value="locationtxt"
          :options="options"
          class="el-input__inner googlesearcher"
          enable-geolocation="true"
          @click="clickInputLocation"
          @place_changed="handlePlaceChanged"
          @keypress.enter="
            $event.preventDefault();
            $event.stopPropagation();
            return false;
          "
        />
        <el-button class="localizebtn" @click="getCurrentPosition">
          <img :src="require('@/assets/brains_icons/pingeneral.png')" width="25px" height="25px" alt="image">
        </el-button>
      </div>
    </el-col>
  </div>
</template>
<script>
import { gmapApi } from 'gmap-vue'
export default {
  name: 'LocationSelector',
  data() {
    return {
      locationtxt: '',
      options: {
        autocompleteTypes: ['geocode'],
        componentRestrictions: { country: 'it' }
      }
    }
  },
  computed: {
    google: gmapApi
  },
  created() {
    const vm = this
    vm.$root.$on('locationaddressfrommap', (address) => {
      vm.locationtxt = address.formatted_address
    })
  },
  methods: {
    clickInputLocation() {
      document.getElementById('autocomplete').value = ''
    },
    handlePlaceChanged(place) {
      const vm = this
      if (place.geometry) {
        this.findLocations(place)
      } else if (new RegExp(/^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi).test(place.name)) {
        var coordinates = place.name.replace(' ', '').split(',')
        const placename = place.name
        place = {
          geometry: {
            location: {
              lat: function() {
                return parseFloat(coordinates[0])
              },
              lng: function() {
                return parseFloat(coordinates[1])
              }
            }
          },
          formatted_address: placename
        }
        vm.findLocations(place)
      } else {
        this.$message({
          message: this.$t('locationSelector.invalidlocation'),
          type: 'error'
        })
      }
    },
    findLocations(place) {
      const vm = this
      vm.$store.dispatch('location/searchlocations', place).then(() => {
        vm.locationtxt = place.formatted_address
      }).catch(() => {
        vm.$message({
          message: vm.$t('locationSelector.invalidlocation'),
          type: 'error'
        })
      })
    },
    getCurrentPosition() {
      const vm = this
      navigator.geolocation.getCurrentPosition(
        function(position) {
          const place = {
            geometry: {
              location: {
                lat: function() {
                  return position.coords.latitude
                },
                lng: function() {
                  return position.coords.longitude
                }
              }
            },
            formatted_address: vm.$t('locationSelector.my-location')
          }
          vm.findLocations(place)
        },
        function(e) {
          vm.$message({
            message: vm.$t('locationSelector.invalidcurrentlocation'),
            type: 'error'
          })
          return
        },
        {
          enableHighAccuracy: true
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.googlesearcher {
  height: 32px;
  max-height: 32px;
  line-height: 32px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
}

.localizebtn {
  position: relative;
  padding: 0 5px !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  background-color: #e9c4684b;
}

.googlesearchgroup {
  display: inline-flex;
  font-size: 8pt;
  // font-family: "Open Sans", Arial, sans-serif;
  min-width: 250px;
}

@media(max-width: 1400px) {
  .googlesearchgroup {
    min-width: initial;
  }
}

#autocomplete {
  font-size: 12px;
  font-family: 'Montserrat-Regular',sans-serif;
}
</style>
